import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

/* js imports */
import useCheckPathName from "../utils/useCheckPathname";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import * as bootstrap from "bootstrap";

/* data imports */
import cartData from "../data/cartData";
import { wheelData } from "../data/wheelData";
import waterData from "../data/waterData";

/* Image imports */
import tinyVivaLogo from "../assets/images/tiny-viva-logo.png";

/* comp imports */
import MainDisclaimerModal from "../components/modals/MainDisclaimerModal";
import PageOverlay from "../components/PageOverlay";
import GiantWheel from "../components/GiantWheel";
import FruitsCart from "../components/FruitsCart";
import HealthyFatsCart from "../components/HealthyFatsCart";
import VegetablesCart from "../components/VegetablesCart";
import ProteinsCart from "../components/ProteinsCart";
import GrainsCart from "../components/GrainsCart";
import FruitsCartLarge from "../components/FruitsCartLarge";
import HealthyFatsCartLarge from "../components/HealthyFatsCartLarge";
import VegetablesCartLarge from "../components/VegetablesCartLarge";
import ProteinsCartLarge from "../components/ProteinsCartLarge";
import GrainsCartLarge from "../components/GrainsCartLarge";
import GrassButterfly from "../components/GrassButterfly";
import Birds from "../components/Birds";
import Tent from "../components/Tent";
import GiantWheelModal from "../components/modals/GiantWheelModal";
import GiantWheelStands from "../components/GiantWheelStands";
import WaterJug from "../components/WaterJug";
import Rainbow from "../components/Rainbow";
import WaterModal from "../components/modals/WaterModal";
import AboutUsBoard from "../components/AboutUsBoard";
import PageTransition from "../components/PageTransition";
import Flags from "../components/Flags";
import Clouds from "../components/Clouds";
import DoctorsBoard from "../components/DoctorsBoard";
import ChefsBoard from "../components/ChefsBoard";
import BlogsBoard from "../components/BlogsBoard";

/* ------ */
window.bootstrap = bootstrap;

const Landing = () => {
  useCheckPathName();
  const navigate = useNavigate();
  const handleRedirect = (pageName) => {
    if (/^https?:\/\//i.test(pageName)) {
      window.open(pageName, "_blank", "noopener,noreferrer");
    } else {
      navigate(pageName);
    }
  };

  const [activeCart, setActiveCart] = useState(0);
  const [activeCartData, setActiveCartData] = useState({});
  const [activeCabinData, setActiveCabinData] = useState({});

  const handleCartClick = (index) => {
    setActiveCart(index);
    setActiveCartData({});
  };

  const handleCartItemClick = (value) => {
    let tempCartItemData = cartData.find((item) => item.name === value);

    if (Object.keys(tempCartItemData).length > 0) {
      setActiveCartData(tempCartItemData);
    }
    const modalElement = document.getElementById("cartModal");
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
  };

  const handleCabinClick = (index) => {
    setActiveCabinData(wheelData[index]);
    const modalElement = document.getElementById("cabinModal");
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
  };

  const handleWaterJugClick = () => {
    const modalElement = document.getElementById("waterModal");
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
  };

  return (
    <>
      <PageTransition />
      {activeCart !== 0 && <PageOverlay />}
      <div className="page-main-wrapper">
        <div className="main-logo">
          <img src={tinyVivaLogo} alt="Tiny Viva Logo" />
        </div>
        <Clouds />
        <Rainbow />
        <GiantWheel handleCabinClick={handleCabinClick} />
        <FruitsCart handleCartClick={handleCartClick} />
        <HealthyFatsCart handleCartClick={handleCartClick} />
        <VegetablesCart handleCartClick={handleCartClick} />
        <ProteinsCart handleCartClick={handleCartClick} />
        <GrainsCart handleCartClick={handleCartClick} />
        <GrassButterfly />
        <Birds />
        <Flags aboveTentClass="main-flag" />
        <AboutUsBoard handleRedirect={handleRedirect} />
        <DoctorsBoard handleRedirect={handleRedirect} />
        <ChefsBoard handleRedirect={handleRedirect} />
        <BlogsBoard handleRedirect={handleRedirect} />
        <Tent handleRedirect={handleRedirect} />
        <GiantWheelStands />
        <WaterJug handleWaterJugClick={handleWaterJugClick} />
      </div>

      {activeCart === 1 && (
        <FruitsCartLarge
          handleCartClick={handleCartClick}
          handleCartItemClick={handleCartItemClick}
          activeCartData={activeCartData}
        />
      )}

      {activeCart === 2 && (
        <HealthyFatsCartLarge
          handleCartClick={handleCartClick}
          handleCartItemClick={handleCartItemClick}
          activeCartData={activeCartData}
        />
      )}
      {activeCart === 3 && (
        <VegetablesCartLarge
          handleCartClick={handleCartClick}
          handleCartItemClick={handleCartItemClick}
          activeCartData={activeCartData}
        />
      )}
      {activeCart === 4 && (
        <ProteinsCartLarge
          handleCartClick={handleCartClick}
          handleCartItemClick={handleCartItemClick}
          activeCartData={activeCartData}
        />
      )}
      {activeCart === 5 && (
        <GrainsCartLarge
          handleCartClick={handleCartClick}
          handleCartItemClick={handleCartItemClick}
          activeCartData={activeCartData}
        />
      )}
      <GiantWheelModal activeCabinData={activeCabinData} />
      <WaterModal waterData={waterData} />
      <MainDisclaimerModal />
    </>
  );
};

export default Landing;
